import React from 'react';

import { Divider } from 'ui-components/components/divider';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { messages } from './supplier-details.messages';
import styles from './supplier-details.styles.module.less';
import { formatAddress } from '../../address-helpers';
import { usePurchaseOrderContext } from '../../purchase-order-context';

/**
 * Supplier Details component
 * Displays the supplier and destination details for a purchase order
 * @param {object} props - Component props
 * @param {object} props.currentSupplier - The supplier data object
 * @param {boolean} props.isLoadingSupplier - Loading state for supplier data
 * @returns {JSX.Element} The supplier details component
 */
export const SupplierDetails = ({ currentSupplier, isLoadingSupplier }) => {
  const { purchaseOrder, warehouses } = usePurchaseOrderContext();

  const warehouseName = warehouses.find((warehouse) => warehouse.key === purchaseOrder.warehouseId)?.name || '';

  return (
    <div className={styles.container}>
      <Text className={styles['section-title']} textType={TextType.H4} value={messages.supplierDetails} />
      <FlexRow className={styles['details-grid']}>
        <FlexColumn className={styles['details-column']}>
          <Text className={styles.label} textType={TextType.Label} value={messages.supplier} />
          {isLoadingSupplier ? (
            <LoadingIndicator className={styles['validation-loading-icon']} />
          ) : (
            <>
              <Text className={styles.value} textType={TextType.Paragraph} value={currentSupplier?.supplierName || ''} />
              <Text className={styles.value} textType={TextType.Paragraph} value={formatAddress(currentSupplier)} />
            </>
          )}
        </FlexColumn>
        <FlexColumn className={styles['details-column']}>
          <Text className={styles.label} textType={TextType.Label} value={messages.destination} />
          <Text className={styles.value} textType={TextType.Paragraph} value={warehouseName} />
        </FlexColumn>
      </FlexRow>
      <Divider className={styles.divider} orientation='horizontal' />
    </div>
  );
};
